/* pfx-bnpl.js — Afterpay "pay in 4" message on the Active ReLeaf PDP.
   ---------------------------------------------------------------------------
   VERIFIED LIVE 2026-08-01 by driving a real checkout on phoilex.com:
     • one-time cart ($49.41)  -> Credit card, Shop Pay (pay in full or in
       installments), PayPal, AFTERPAY.
     • subscription cart ($42) -> Credit card, PayPal ONLY. No Afterpay, no
       Shop Pay installments (BNPL cannot service a recurring contract).
   => The message is shown ONLY while Subscribe & Save is OFF. Promising
      Afterpay next to a subscribe price would break at checkout.

   Why Afterpay and not Shop Pay Installments: Shop Pay's 4-biweekly
   interest-free tier starts at $50 and the 1-Tube one-time price is $49.41,
   so the entry tier would not qualify. Afterpay covers all three tiers.

   Price source: the bundle bar is a frozen snapshot repriced by
   pfx_interactivity.v4.js, which rewrites .pfx-bundles__bar-price and keeps the
   subscribe price in data-pfx-base. We read the DISPLAYED price of the selected
   tier so this line can never disagree with the number above it (any currency,
   any future price change, no hardcoded amounts). */
(function () {
  'use strict';

  var SUB_RATE = 0.15;      // must match PFX_SUB_RATE in pfx_interactivity.v4.js
  var MIN = 35;             // Afterpay US order floor
  var MAX = 1000;           // Afterpay US order ceiling
  var ID = 'pfx-bnpl';

  function css() {
    if (document.getElementById(ID + '-css')) return;
    var s = document.createElement('style');
    s.id = ID + '-css';
    s.textContent =
      '#' + ID + '{display:none;align-items:center;justify-content:center;gap:7px;' +
      'flex-wrap:wrap;margin:10px 0 2px;padding:9px 12px;border:1px solid #e4e4e4;' +
      'border-radius:10px;background:#fafafa;font-size:14px;line-height:1.35;' +
      'color:#1a1a1a;text-align:center}' +
      '#' + ID + '.pfx-bnpl-on{display:flex}' +
      '#' + ID + ' b{font-weight:700}' +
      '#' + ID + ' .pfx-bnpl-mark{display:inline-block;padding:2px 8px;border-radius:999px;' +
      'background:#b2fce4;color:#000;font-weight:700;font-size:13px;letter-spacing:-.2px;' +
      'white-space:nowrap}' +
      '@media(max-width:479px){#' + ID + '{font-size:13px;padding:8px 10px}}';
    (document.head || document.documentElement).appendChild(s);
  }

  function selectedPriceEl() {
    var bar = document.querySelector('.pfx-bundles__bar--selected');
    return (bar && bar.querySelector('.pfx-bundles__bar-price')) ||
           document.querySelector('.pfx-bundles__bar-price');
  }

  function subscribeOn() {
    var card = document.querySelector('.pfx-bundles__subscriptions');
    return !!(card && card.classList.contains('pfx-sub-on'));
  }

  /* One-time price of the selected tier.
     Subscribe OFF -> the displayed price already IS the one-time price.
     Subscribe ON  -> displayed is the deal price; one-time = base / (1 - rate). */
  function oneTimePrice(el) {
    if (!el) return null;
    var shown = parseFloat(String(el.textContent || '').replace(/[^\d.]/g, ''));
    if (!subscribeOn() && isFinite(shown)) return shown;
    var base = parseFloat(el.getAttribute('data-pfx-base'));
    if (isFinite(base)) return base / (1 - SUB_RATE);
    return isFinite(shown) ? shown : null;
  }

  function symbol(el) {
    var m = String((el && (el.getAttribute('data-pfx-sample') || el.textContent)) || '')
      .match(/^\s*([^\d.,\s]*)/);
    return (m && m[1]) || '$';
  }

  function node() {
    var n = document.getElementById(ID);
    if (n) return n;
    var anchor = document.querySelector('.pfx-bundles__subscriptions') ||
                 document.querySelector('.pfx-bundles__bars');
    if (!anchor || !anchor.parentNode) return null;
    n = document.createElement('div');
    n.id = ID;
    n.setAttribute('role', 'note');
    anchor.parentNode.insertBefore(n, anchor.nextSibling);
    return n;
  }

  function render() {
    css();
    var n = node();
    if (!n) return;
    var el = selectedPriceEl();
    var total = oneTimePrice(el);

    if (subscribeOn() || !total || total < MIN || total > MAX) {
      n.classList.remove('pfx-bnpl-on');
      return;
    }
    var each = symbol(el) + (total / 4).toFixed(2);
    var html = 'or 4 interest-free payments of <b>' + each + '</b> with ' +
               '<span class="pfx-bnpl-mark">Afterpay</span>';
    if (n.innerHTML !== html) n.innerHTML = html;
    n.classList.add('pfx-bnpl-on');
  }

  /* Render SYNCHRONOUSLY, then once more on a short trailing timer.
     Two things forced this shape, both verified against the live PDP:
       1. requestAnimationFrame is paused while the tab is hidden, so a page
          opened in a background tab would never paint this line at all.
       2. setTimeout is throttled to ~1s in a hidden tab, so a timer-only
          update showed the PREVIOUS tier's amount after a tier switch.
     The synchronous call (driven by the MutationObserver, which is not
     throttled) keeps the amount correct; the trailing timer catches the case
     where the bundle app updates .pfx-bundles__bar--selected after our
     capture-phase click handler has already run. */
  var queued = false;
  function schedule() {
    render();
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; render(); }, 30);
  }

  function boot() {
    var block = document.querySelector('.pfx-bundles__block') ||
                document.querySelector('.pfx-bundles');
    if (!block) return false;
    render();
    // tier clicks + subscribe toggle
    block.addEventListener('click', schedule, true);
    block.addEventListener('change', schedule, true);
    // pfx_interactivity rewrites price text / toggles .pfx-sub-on
    new MutationObserver(schedule).observe(block, {
      subtree: true, childList: true, characterData: true,
      attributes: true, attributeFilter: ['class']
    });
    return true;
  }

  function start() {
    if (boot()) return;
    var tries = 0;
    var t = setInterval(function () {
      if (boot() || ++tries > 60) clearInterval(t);   // bundle block renders async
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
